import { Injectable } from '@angular/core';

export interface GungEvent {
  /**
     * Should be a UUID-V4 unique identifier. Important for idempotency of events.
    */
  id: string

  /**
    * The event type
   */
  eventType: string;
  /**
    * The version of the event schema. The version depends on the eventType, i.e. "event1" might be on version 1,
    * "event2" on version 3, etc.
   */
  eventVersion: number;

  /**
    * The instant when the event occurred. ISO 8601
   */
  occuredAt: string;
  /**
    * The instant when the event was received by the backend system. ISO 8601
   */
  receivedAt?: string;

  /**
    * The source of the event, i.e. which system produced it. For example "web" from the frontend, "edi", etc.
   */
  source: string;

  /**
    * The tenant / account / organization for whom the event happened for. This is our customers id. i.e. at the time
    * of writing their Fortnox id.
   */
  tenantId?: string;

  /**
    * The selected customer for whom the event happened for / with. The customer in this case is our customers, customer,
    * i.e. {@link io.gung.model.Customer#getId()}. Can be null if the event is not associated with a specific customer.
   */
  customerId: string;

  /**
    * The user that the event is associated with, if any. Could be null for system events.
   */
  userId: string;

  /**
    * The roles the user has associated.
   */
  userRoles: string[];

  /**
    * The browser / app session id, if any.
   */
  sessionId: string;

  /**
    * Client information if applicable. Could include ips, frontend domain, app version, selected language, etc.
   */
  clientContext: { [s: string]: any };

  /**
    * The actual event payload / data. Will differ between event types and versions.
   */
  payload: { [s: string]: any };
}

@Injectable({
  providedIn: 'root'
})
export class GungCommonEventSystemService {
  public emitGungEvent(eventType: string, eventPayload: { [s: string]: any }, overrideEventVersion?: number): void {
  }

  public emitMultipleGungEvents(gungEvents: { eventType: string, eventPayload: { [s: string]: any }, overrideEventVersion?: number }[]): void {
  }
}
